import React from "react";
import type { TabProps } from "@mui/material";
import XTab from "@mui/material/Tab";

const Tab: React.FC<TabProps> = (props) => {
  return <XTab {...props}/>
};

export default Tab;
